import { render, staticRenderFns } from "./help-records.vue?vue&type=template&id=4e106cf6&scoped=true"
import script from "./help-records.vue?vue&type=script&lang=js"
export * from "./help-records.vue?vue&type=script&lang=js"
import style0 from "./help-records.vue?vue&type=style&index=0&id=4e106cf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e106cf6",
  null
  
)

export default component.exports